export const PreviewStepTestIds = {
  ROOT: 'preview-step',
  DOCUMENT_PANE: 'preview-step-document-pane',
  GENERATING: 'preview-step-generating',
  ERROR: 'preview-step-error',
  UNAVAILABLE: 'preview-step-unavailable',
  RETRY_BUTTON: 'preview-step-retry',
  KEY_NUMBERS: 'preview-step-key-numbers',
  BASELINE_NOTE: 'preview-step-baseline-note',
  REVIEW_CARD: 'preview-step-review-card',
  REVIEW_CHECKBOX: 'preview-step-review-checkbox',
  getKeyNumberTestId: id => `preview-step-key-number-${id}`,
};
